import * as Yup from 'yup';
import impactFactsSchema from './impactFacts.schemas';
import feedbackBlockSchema from './feedbackBlock.schemas';
import productsBlockSchema from './productsBlock.schema';
import moreInfoBlockSchema from './moreInfoBlock.schemas';
import verifiedPaymentsBlockSchema from './verifiedPaymentsBlock.schemas';
import productJourneySchema from './productJourney.schemas';
import productAboutSchema from './aboutBlock.schemas';

export const createProductSchema = Yup.object().shape({
  title: Yup.string().required('This field is required'),
  articleNumber: Yup.string().nullable().default(''),
  slug: Yup.string()
    .required('This field is required')
    .matches(/^[a-zA-Z0-9-]+$/, 'Cannot contain special characters or spaces'),
  languageConfig: Yup.object().shape({
    default: Yup.string().default('en'),
    enabled: Yup.array().default(['en']),
  }),
});

export const productLanguageSchema = Yup.object().shape({
  languageConfig: Yup.object().shape({
    default: Yup.string().default('en'),
  }),
});

export const contentBlockSchema = {
  ABOUT_BLOCK: { schema: productAboutSchema, name: 'AboutBlock' },
  PRODUCT_JOURNEY_BLOCK: { schema: productJourneySchema, name: 'ProductJourneyBlock' },
  IMPACT_FACTS_BLOCK: { schema: impactFactsSchema, name: 'ImpactFactsBlock' },
  MORE_INFO_BLOCK: { schema: moreInfoBlockSchema, name: 'MoreInfoBlock' },
  PRODUCTS_BLOCK: { schema: productsBlockSchema, name: 'ProductsBlock' },
  FEEDBACK_BLOCK: { schema: feedbackBlockSchema, name: 'FeedbackBlock' },
  VERIFIED_PAYMENT_BLOCK: { schema: verifiedPaymentsBlockSchema, name: 'VerifiedPaymentsBlock' },
};
